import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { FilterStatus } from './types';

export const filterStatusSlice = createSlice({
    name: 'filterStatus',
    initialState: {
      filterStatus: 'online'
    } as FilterStatus,
    reducers: {
      setOnline: (state) => {
        //state.filterStatus = state.filterStatus === 'online' ? 'all' : 'online';

        // States can be online or offline or all
        if(state.filterStatus === 'all'){
            state.filterStatus = 'offline';
        } else if (state.filterStatus === 'online'){
          state.filterStatus = 'online';
        } else {
          state.filterStatus = 'all'
        }
      },
      setOffline: (state) => {
        //state.filterStatus = state.filterStatus === 'offline' ? 'all' : 'offline';

        // States can be online or offline or all
        if(state.filterStatus === 'all'){
          state.filterStatus = 'online';
        } else if (state.filterStatus === 'offline'){
          state.filterStatus = 'offline';
        } else {
          state.filterStatus = 'all'
        }
      },
    },
  });
  
  export const { setOnline, setOffline } = filterStatusSlice.actions;
  
  export const getFilterStatus = (state: RootState) => state.filterStatus.filterStatus;
  
  export default filterStatusSlice.reducer;
  